import React from 'react'
import styled from 'styled-components'
import media from '../../utils/style'
import { Flex, Box } from 'rebass'
import IconArrowDown from '../../vectors/IconArrowDown'
import { func, array, bool, string } from 'prop-types'

const Wrapper = styled(Flex)`
  background-color: white;
  &:last-child {
    ${media.LargeScreenUp`
        border-bottom: 1px ${(props) =>
          props.theme.colors.grey_light_op30} solid;
    `};
  }
`

const Header = styled(Box)`
  cursor: pointer;
  background-color: ${(props) =>
    props.open ? props.theme.colors.white : props.theme.colors.blue_light};
  color: ${(props) => props.theme.colors.blue};
  font-weight: ${(props) => props.theme.weights[1]};
  border-top: 1px ${(props) => props.theme.colors.grey_light_op30} solid;
`

const Arrow = styled(IconArrowDown)`
  display: inline-block;
  margin-right: 15px;
  margin-left: 3px;
  margin-top: -3px;
  transform: scale(${(props) => (props.open ? '1.5' : '-1.5')});
`

const FilterBody = styled(Box)``

const RightOptional = styled.span`
  float: right;
  font-weight: ${(props) => props.theme.weights[0]};
`

const CurrentValue = styled.span`
  color: ${(props) => props.theme.colors.grey_light};
`
CurrentValue.displayName = 'CurrentValue'

const ClearLink = styled.span`
  text-decoration: none;
  font-weight: ${(props) => props.theme.weights[0]};
  color: ${(props) => props.theme.colors.blue};

  &:hover {
    color: ${(props) => props.theme.colors.grey};
  }
`
ClearLink.displayName = 'ClearLink'

const TitleLink = styled.span`
  text-decoration: none;
  color: ${(props) => props.theme.colors.blue};

  &:hover {
    color: ${(props) => props.theme.colors.grey};

    path {
      fill: ${(props) => props.theme.colors.grey};
    }
  }
`
TitleLink.displayName = 'TitleLink'

class VehicleListingFilterAccordion extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isCollapsed: props.collapsed || this.props.selected.length > 0
    }
    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.reverseDisplay = this.reverseDisplay.bind(this)
  }

  show(e) {
    if (e) e.preventDefault()
    this.setState({ isCollapsed: false })
  }

  hide(e) {
    if (e) e.preventDefault()
    this.setState({ isCollapsed: true })
  }

  reverseDisplay(e) {
    if (e) e.preventDefault()
    if (this.state.isCollapsed) this.show()
    else this.hide()
  }

  render() {
    const isPopulated = this.props.selected.length > 0
    const tabPanelId = this.props.title.replace(/\s+/g, '').toLowerCase()
    const FilterBodyContent = !this.state.isCollapsed ? (
      <FilterBody
        width={12 / 12}
        pt={20}
        pb={0}
        px={20}
        role="tabpanel"
        id={`tabpanel:${tabPanelId}`}
      >
        {this.props.children}
      </FilterBody>
    ) : null

    return (
      <Wrapper flexWrap="wrap">
        <Header
          width={12 / 12}
          py={10}
          px={30}
          open={this.state.isCollapsed}
          onClick={this.reverseDisplay}
          role="tablist"
        >
          <TitleLink
            tabIndex="0"
            role="tab"
            aria-controls={`tabpanel:${tabPanelId}`}
          >
            <Arrow open={this.state.isCollapsed} />
            {this.props.title}
          </TitleLink>
          <RightOptional>
            {isPopulated && (
              <ClearLink
                onClick={(e) => {
                  e.stopPropagation()
                  this.props.onClear()
                }}
                role="button"
              >
                Clear{' '}
                {this.props.selected.length > 1
                  ? `(${this.props.selected.length})`
                  : ''}
              </ClearLink>
            )}
            {!isPopulated && <CurrentValue>Any</CurrentValue>}
          </RightOptional>
        </Header>
        {FilterBodyContent}
      </Wrapper>
    )
  }
}

VehicleListingFilterAccordion.defaultProps = {
  onClear: (f) => f,
  selected: [],
  collapsed: false
}
VehicleListingFilterAccordion.propTypes = {
  onClear: func,
  selected: array,
  collapsed: bool,
  title: string
}
export default VehicleListingFilterAccordion
